"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfManageDigestResponseDto = instanceOfManageDigestResponseDto;
exports.ManageDigestResponseDtoFromJSON = ManageDigestResponseDtoFromJSON;
exports.ManageDigestResponseDtoFromJSONTyped = ManageDigestResponseDtoFromJSONTyped;
exports.ManageDigestResponseDtoToJSON = ManageDigestResponseDtoToJSON;
exports.ManageDigestResponseDtoToJSONTyped = ManageDigestResponseDtoToJSONTyped;
var ManageDigestSportDto_1 = require("./ManageDigestSportDto");
/**
 * Check if a given object implements the ManageDigestResponseDto interface.
 */
function instanceOfManageDigestResponseDto(value) {
    if (!('sportCodes' in value) || value['sportCodes'] === undefined)
        return false;
    if (!('hiddenSportCodes' in value) || value['hiddenSportCodes'] === undefined)
        return false;
    if (!('sports' in value) || value['sports'] === undefined)
        return false;
    return true;
}
function ManageDigestResponseDtoFromJSON(json) {
    return ManageDigestResponseDtoFromJSONTyped(json, false);
}
function ManageDigestResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'sportCodes': json['sportCodes'],
        'hiddenSportCodes': json['hiddenSportCodes'],
        'sports': (json['sports'].map(ManageDigestSportDto_1.ManageDigestSportDtoFromJSON)),
    };
}
function ManageDigestResponseDtoToJSON(json) {
    return ManageDigestResponseDtoToJSONTyped(json, false);
}
function ManageDigestResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'sportCodes': value['sportCodes'],
        'hiddenSportCodes': value['hiddenSportCodes'],
        'sports': (value['sports'].map(ManageDigestSportDto_1.ManageDigestSportDtoToJSON)),
    };
}
